import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

function normalizeCategoryPayload(data) {
  if (!data || typeof data !== 'object') return data;
  const next = { ...data };
  // Backend currently validates title as string on several category endpoints.
  if (next.title && typeof next.title === 'object' && !Array.isArray(next.title)) {
    next.title =
      next.title.en ??
      next.title.it ??
      next.title.de ??
      next.title.fr ??
      Object.values(next.title)[0] ??
      '';
  }
  return next;
}

const categoryService = {
  getAll: (params) =>
    request.get('dashboard/admin/categories/paginate', { params }),
  getAllMain: (params) => request.get('dashboard/admin/categories', { params }),
  selectPaginate: (params) =>
    request.get('dashboard/admin/categories/select-paginate', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/categories/${id}`, { params }),
  create: (data) =>
    request.post('dashboard/admin/categories', normalizeCategoryPayload(data)),
  update: (id, data) =>
    request.put(
      `dashboard/admin/categories/${id}`,
      normalizeCategoryPayload(data),
    ),
  delete: (data) =>
    request.delete(`dashboard/admin/categories/delete`, { data }),
  deleteByUuid: (uuid) =>
    request.delete(`dashboard/admin/categories/${uuid}`),
  search: (params) =>
    request.get('dashboard/admin/categories/search', { params }),
  setActive: (id) => request.post(`dashboard/admin/categories/${id}/active`),
  dropAll: () => request.get(`dashboard/admin/categories/drop/all`),
  restoreAll: (params) =>
    request.get(`dashboard/admin/categories/restore/all`, { params }),
  export: (params) =>
    requestWithoutTimeout.get('dashboard/admin/categories/export', { params }),
  import: (data) =>
    requestWithoutTimeout.post('dashboard/admin/categories/import', data),
  updatePosition: (uuid, data) =>
    request.post(`dashboard/admin/category-input/${uuid}`, data),
  paginateSelect: (params) =>
    request.get('dashboard/admin/categories/select-paginate', { params }),
  statusUpdate: (id, data) =>
    request.post(`dashboard/admin/categories/${id}/status`, data),
  deleteImage: (uuid) =>
    request.post(`dashboard/admin/categories/${uuid}/image/delete`),
};

export default categoryService;
